//
//
//
//

import { imagePlaceholderProduct } from "~/common";
import MoominImage from "~/themes/fiskarsMoominDefault/components/components/atoms/MoominImage/MoominImage.vue";

export default {
  name: "MoominFullWidthImage",
  components: {
    MoominImage,
  },
  props: {
    image: {
      type: Object,
      required: true,
      default: {
        desktop: imagePlaceholderProduct,
        mobile: imagePlaceholderProduct,
        thumbnail: imagePlaceholderProduct,
        alt: "image",
      },
    },
  },
};
